// ===== Blomstrende Søskende theme.js =====

// --- Cutoff-logik (ugedagsbevidst) ---
// Efter fredag kl. 14, lørdag og søndag er næste cutoff mandag kl. 14,
// og "i morgen"-løfter skiftes til "mandag".
(function(){
  var srcEl = document.getElementById('cutoffTimer');
  var hour = parseInt((srcEl && srcEl.dataset.cutoffHour) || '14', 10);

  function inWeekendWindow(){
    var now = new Date();
    var d = now.getDay();
    if(d === 6 || d === 0) return true; // lør/søn
    if(d === 5){ var c = new Date(now); c.setHours(hour,0,0,0); return now > c; } // fredag efter cutoff
    return false;
  }

  // Ret leverings-løfter i weekend-vinduet (før timer-elementet slås op,
  // da innerHTML-erstatning genskaber DOM-noder)
  if(inWeekendWindow()){
    ['.announce','.cutoff','.sticky-atc .p small','.ship-note','.guarantees span'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(node){
        if(node.innerHTML.indexOf('i morgen') !== -1){
          node.innerHTML = node.innerHTML.replace(/i morgen/g, 'mandag');
        }
      });
    });
  }

  var el = document.getElementById('cutoffTimer');
  if(!el) return;

  function nextCutoff(){
    var now = new Date();
    var c = new Date(now);
    c.setHours(hour,0,0,0);
    if(now > c) c.setDate(c.getDate()+1);
    while(c.getDay() === 0 || c.getDay() === 6){ c.setDate(c.getDate()+1); }
    return c;
  }

  function tick(){
    var d = nextCutoff() - new Date();
    var h = String(Math.floor(d/3.6e6)).padStart(2,'0');
    var m = String(Math.floor(d%3.6e6/6e4)).padStart(2,'0');
    var s = String(Math.floor(d%6e4/1e3)).padStart(2,'0');
    el.textContent = h+':'+m+':'+s;
  }
  tick(); setInterval(tick,1000);
})();

// --- Mobilmenu ---
(function(){
  var btn = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.nav-links');
  if(!btn || !nav) return;
  btn.addEventListener('click', function(){
    nav.classList.toggle('open');
    btn.classList.toggle('open');
    btn.setAttribute('aria-expanded', nav.classList.contains('open'));
  });
})();

// --- 2-trins popup (micro-commitment) + rabatkode direkte på sitet ---
// Trin 1: valg (hvem køber du til?) → Trin 2: e-mail → Trin 3: koden vises.
// Efter form-post reloader Shopify siden med ?customer_posted=true — så viser vi trin 3.
(function(){
  var p = document.getElementById('popup');
  var posted = window.location.search.indexOf('customer_posted=true') !== -1;

  function show(step){
    p.querySelectorAll('.step').forEach(function(s){ s.classList.remove('active'); });
    var t = p.querySelector('.step-' + step);
    if(t) t.classList.add('active');
    p.classList.add('show');
  }

  if(p){
    // Trin 1 → 2: gem valget som kunde-tag (interesse-<valg>)
    p.querySelectorAll('.chip').forEach(function(c){
      c.addEventListener('click', function(){
        var tags = p.querySelector('[data-popup-tags]');
        if(tags && tags.value.indexOf('interesse-') === -1) tags.value += ',interesse-' + c.dataset.choice;
        show(2);
      });
    });

    p.addEventListener('click', function(e){
      if(e.target === p || e.target.closest('[data-popup-close]')) p.classList.remove('show');
    });

    // Succes: vis koden med det samme — kunden skal ikke fiske den frem i mailen
    if(posted){ show(3); return; }

    // Normal visning: forsinket, max 1 pr. session
    if(!sessionStorage.getItem('bsPopupShown')){
      setTimeout(function(){
        show(1);
        sessionStorage.setItem('bsPopupShown','1');
      }, parseInt(p.dataset.delay || '12', 10) * 1000);
    }
  } else if(posted){
    // Fallback-toast hvis popup er slået fra
    var b = document.createElement('div');
    b.className = 'signup-toast';
    b.innerHTML = 'Tak for din tilmelding! 🌷 Din rabatkode: <b>VELKOMST15</b> — 15 % på din første buket. <button aria-label="Luk">×</button>';
    document.body.appendChild(b);
    b.querySelector('button').addEventListener('click', function(){ b.remove(); });
  }
})();

// --- PDP: varianter, add-ons, abonnement, dynamisk pris, kurv ---
(function(){
  var form = document.getElementById('ProductForm');
  if(!form) return;

  var dataEl = document.getElementById('ProductJSON');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var variantInput = form.querySelector('input[name="id"]');
  var planInput = form.querySelector('input[name="selling_plan"]');

  var state = {
    variantId: parseInt(variantInput.value, 10),
    price: parseInt(form.dataset.initialPrice, 10), // i øre
    addons: 0,
    isSub: false,
    planId: ''
  };

  var canPurchase = false;
  function fmt(cents){
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: form.dataset.currency || 'DKK' }).format(cents / 100);
  }

  function render(){
    var variant = variants.find(function(v){ return v.id === state.variantId; });
    if(!variant) return;
    var allocation = (variant.plans || []).find(function(p){ return String(p.id) === state.planId; });
    var base = allocation ? allocation.price : variant.price;
    var before = allocation ? Math.max(allocation.compare_at_price || 0, variant.compare_at_price || 0) : (variant.compare_at_price || 0);
    var saving = Math.max(0, before - base);
    var percent = before > 0 ? Math.round(saving * 1000 / before) / 10 : 0;
    var savingText = saving > 0 ? 'Spar ' + fmt(saving) + ' (' + String(percent).replace('.', ',') + ' %)' : '';
    var total = base + state.addons;
    var suffix = allocation ? ' /levering' : '';
    var p = document.getElementById('pdpPrice');
    // Savings concern the bouquet; add-ons only change the button / basket total.
    if(p){
      p.querySelector('[data-current-price]').textContent = fmt(base) + suffix;
      p.querySelector('[data-before-price]').hidden = !saving;
      p.querySelector('[data-before-amount]').textContent = fmt(before);
      p.querySelector('[data-price-saving]').hidden = !saving;
      p.querySelector('[data-price-saving]').textContent = savingText;
    }
    var b = document.getElementById('btnPrice');
    var sp = document.getElementById('stickyPrice');
    var ss = document.getElementById('stickySaving');
    if(b) b.textContent = fmt(total);
    if(sp) sp.textContent = fmt(total);
    if(ss){ ss.hidden = !saving; ss.textContent = savingText + ' på buketten'; }
    canPurchase = variant.available && (!state.planId || !!allocation) && (!variant.requires_selling_plan || !!allocation);
    var label = variant.available ? 'Vælg abonnement' : 'Udsolgt';
    form.querySelector('button[type="submit"]').disabled = !canPurchase;
    form.querySelector('[data-submit-label]').textContent = canPurchase ? 'Læg i kurv —' : label;
    if(b) b.hidden = !canPurchase;
    var stickyButton = document.querySelector('button[form="ProductForm"]');
    if(stickyButton){ stickyButton.disabled = !canPurchase; stickyButton.textContent = canPurchase ? 'Læg i kurv' : label; }
  }

  // Størrelse
  form.querySelectorAll('.size').forEach(function(el){
    el.addEventListener('click', function(){
      form.querySelectorAll('.size').forEach(function(s){ s.classList.remove('active'); s.setAttribute('aria-pressed', 'false'); });
      el.classList.add('active');
      el.setAttribute('aria-pressed', 'true');
      state.variantId = parseInt(el.dataset.variantId, 10);
      state.price = parseInt(el.dataset.price, 10);
      variantInput.value = state.variantId;
      var sticky = document.getElementById('stickySize');
      if(sticky) sticky.textContent = el.dataset.title;
      render();
    });
  });

  // Add-ons (separate produkter — lægges i kurven sammen med hovedproduktet)
  form.querySelectorAll('input[data-addon-variant]').forEach(function(cb){
    cb.addEventListener('change', function(){
      state.addons = 0;
      form.querySelectorAll('input[data-addon-variant]:checked').forEach(function(c){
        state.addons += parseInt(c.dataset.price, 10);
      });
      render();
    });
  });

  // Engangskøb vs. abonnement (alle selling plans)
  form.querySelectorAll('.p-opt').forEach(function(el){
    el.addEventListener('click', function(){
      form.querySelectorAll('.p-opt').forEach(function(p){ p.classList.remove('active'); });
      el.classList.add('active');
      var radio = el.querySelector('input[type="radio"]');
      if(radio) radio.checked = true;
      state.planId = el.dataset.planId || '';
      state.isSub = !!state.planId;
      if(planInput) planInput.value = state.planId;
      render();
    });
  });

  // Submit: hovedprodukt (+ evt. selling plan + properties) og add-ons i ét kald
  form.addEventListener('submit', function(e){
    e.preventDefault();
    if(!canPurchase) return;
    var items = [];
    var main = { id: state.variantId, quantity: 1, properties: {} };
    if(state.planId) main.selling_plan = state.planId;
    form.querySelectorAll('[data-line-property]').forEach(function(inp){
      if(inp.value.trim()) main.properties[inp.dataset.lineProperty] = inp.value.trim();
    });
    var card = form.querySelector('input[data-free-card]');
    if(card && card.checked && main.properties['Hilsen på kort'] === undefined){
      main.properties['Håndskrevet kort'] = 'Ja';
    }
    items.push(main);
    form.querySelectorAll('input[data-addon-variant]:checked').forEach(function(c){
      items.push({ id: parseInt(c.dataset.addonVariant, 10), quantity: 1 });
    });

    var btn = form.querySelector('button[type="submit"]');
    if(btn){ btn.disabled = true; btn.style.opacity = '.7'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if(!r.ok) throw new Error('Cart error');
      window.location.href = '/cart';
    }).catch(function(){
      if(btn){ btn.disabled = false; btn.style.opacity = '1'; }
      alert('Noget gik galt — prøv igen, eller ring til os.');
    });
  });

  render();
})();
